// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1mqpK","ranges":"BmiRanges_ranges__5Fpoo"};